import React from 'react';
import { Link } from "react-router-dom";
import Facility from '@/features/facility/shared/types/Facility';

type LensMenuProps = {
  facility?: Facility;
}

const LensMenu: React.FC<LensMenuProps> = ({
  facility
}) => {
  return (
    <main id="page-facility_login" className="wrapper">
      <section className="sec-contact">
        <div className="inner">
          <h1 className="c-ttl__01">レンズ注文</h1>
        </div>
      </section>
      <div className="sec-link">
        <div className="inner">
          <ul className="link-list">
            <li className="link-list__item">
              <Link to="/facility/orders/commercial_lens"> 製品レンズ注文 </Link>
            </li>
            <li className="link-list__item">
              <Link to="/facility/orders/trial_lens">トライアルレンズ注文</Link>
            </li>
            {facility?.isFlatRate &&
              <li className="link-list__item">
                <Link to="/facility/orders/flat_rate_lens">定額制注文</Link>
              </li>
            }
            {facility?.isFacilityFlatRate &&
              <li className="link-list__item">
                <Link to="/facility/orders/facility_lens">施設型定額制レンズ注文</Link>
              </li>
            }
          </ul>
        </div>
      </div>
    </main>
  )
}

export default LensMenu;
